module.exports = __webpack_public_path__ + "img/derRoteBlitz.f4d90dfd.jpg";